<mdb-sidenav-layout>
  <mdb-sidenav
    #sidenav="mdbSidenav"
    data-cy="sidenav-perpetrator"
    [width]="400"
    [right]="true"
  >
    <div class="position-relative h-100">
      <header class="d-flex justify-content-between align-items-center p-2 navbar">
        <p class="mb-0 fw-bold text-muted">Threat Pairs</p>
        <button type="button" class="btn-transparent" (click)="onClose()" aria-label="Close">
          <i class="fas fa-xmark"></i>
        </button>
      </header>

      
        <!--<span class="fw-medium text-gray-dark">{{ counterpartRole }}</span>-->
      <div class="pt-2"></div>
      <div class="p-2">
        <div class="d-flex align-items-start gap-1">
          <span
            class="rounded-circle bg-gray text-white fw-bold d-flex align-items-center justify-content-center flex-shrink-0"
            style="width: 32px; height: 32px; font-size: 12px"
          >{{ counterpartUser?.initials }}</span>
          <div class="d-flex flex-column flex-grow-1">
            <span class="fw-medium text-gray-dark">{{ counterpartUser?.name }}</span>
            @if (counterpartUser?.organization?.name) {
            <span class="badge rounded-pill bg-opacity-10 bg-info text-info align-self-start">{{
              counterpartUser?.organization?.name }}</span>
            }
            <div class="d-flex gap-2 small text-muted mb-1 align-items-center">
              <span class="d-inline-flex align-items-center gap-1">
                <i class="fas fa-map-marker-alt"></i>
                {{ selectedPair?.distanceThreshold || 0 }} {{ selectedPair?.distanceParameter === 'meter' ? 'm' : selectedPair?.distanceParameter === 'feet' ? 'ft' : selectedPair?.distanceParameter === 'yard' ? 'yd' : selectedPair?.distanceParameter === 'mile' ? 'mi' : '' }}
              </span>
              <span class="d-inline-flex align-items-center gap-1">
                <span
                  class="rounded-circle flex-shrink-0 d-inline-block"
                  [ngClass]="selectedPair?.status?.toLowerCase() === 'active' ? 'bg-success' : 'bg-secondary'"
                  style="width: 6px; height: 6px"
                ></span>
                {{ selectedPair?.status | titlecase }}
              </span>
            </div>
          </div>
          <button
            type="button"
            class="perpetrator-sidebar-alert-btn btn btn-sm rounded-1 d-inline-flex align-items-center gap-1 align-self-start flex-shrink-0"
            (click)="onAlert()"
          >
            <i-bs name="exclamation-triangle-fill" width="12" height="12"></i-bs>
            Alert
          </button>
        </div>
        <hr class="my-1" />
      </div>
    </div>
  </mdb-sidenav>
  <mdb-sidenav-content #sidenavContent></mdb-sidenav-content>
</mdb-sidenav-layout>
